import { CbInputModule } from '@chubb/ui-components/cb-input';
import { CbIconModule } from '@chubb/ui-components/cb-icon';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmailComponent } from './email.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CSBCoreModule } from '../../../csb-core/csb-core.module';
@NgModule({
    declarations: [EmailComponent],
    imports: [
        CommonModule,
        CbInputModule,
        CbIconModule,
        FormsModule,
        ReactiveFormsModule,
        CSBCoreModule,
    ],
    exports: [EmailComponent],
})
export class EmailModule {}
